/* eslint-disable camelcase */
import React from 'react'
import { DeleteFilled, LinkOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Card, Col, Collapse, Divider, Input as AntdInput, Row, Select, Table, Tooltip, Typography } from 'antd'
import moment from 'moment-timezone'
import PropTypes from 'prop-types'
import { HeroBasicInfo, RichTextContentEditor, PageMetaInfo, PriceCards, FAQModules, FAQPageSections, FAQAttendingFields, FAQHeroFields, TourMarketingCard, HorizontalBanner, DatafieldGallery, PageForm, MediaRow, MarketingPills, PopularSearchesSection, ConcessionPageSections, VenueRentalsHeroFields, RecommendationsSelector, ContentCard, ContentModuleBasicInfo, Flockler, SuiteCardBasicInfo, AnchorLinks, InternalSearchOptimization } from '~components'
import { PAGE_TYPES_PREMIUM_EDITOR, VENUE_RENTALS_PAGE_TYPE, VLP_BASE_URL } from '~constants'
import { DatePicker, Input, MultiSelectDropdown, Checkbox } from '~stories'
import {
  FAQ_SLUG_SUFFIX_RE,
  buildConcessionSlugFromVenue,
  buildVenueRentalsSlugFromVenue,
  CONCESSION_SLUG_SUFFIX,
  getFaqSlugPrefix,
  getFaqSlugSuffix,
  isValidConcessionSlug,
  isValidFaqSlug,
  isValidVenueRentalsSlug,
  VENUE_RENTALS_SLUG_SUFFIX
} from '../../utils/faqSlugFromVenueName'
import { disabledExpiryDate, disabledExpiryTime } from '../../utils/universalTemplateExpiryPicker'
import {
  getUniversalTemplateSlugPrefix,
  getUniversalTemplateSlugSuffix,
  isValidUniversalTemplateSlug,
  UNIVERSAL_TEMPLATE_SLUG_SUFFIX_RE
} from '../../utils/universalTemplateSlugFromName'
import UniversalTemplateModules from '../UniversalTemplateModules/UniversalTemplateModules'

import styles from './PageBasicInfo.module.css'

const { Panel } = Collapse
const { Title } = Typography
const { REACT_APP_STAGE } = process.env

const upcomingEventsColumns = [
  {
    title: 'Event Name',
    dataIndex: 'name',
    render: (text, row) => <a href={`/events/${row.id}`}>{row.name}</a>,
    width: '25%'
  },
  {
    dataIndex: 'formatted_start_date',
    title: 'Start Date',
    width: '10%'
  },
  {
    dataIndex: 'formatted_start_time',
    title: 'Start Time',
    width: '10%'
  }
]

const todaysEventColumns = [
  {
    title: 'Event Name',
    dataIndex: 'name',
    render: (text, row) => <a href={`/events/${row.id}`}>{row.name}</a>,
    width: '25%'
  },
  {
    dataIndex: 'formatted_start_date',
    title: 'Start Date',
    width: '10%'
  },
  {
    dataIndex: 'formatted_start_time',
    title: 'Start Time',
    width: '10%'
  }
]

const PageBasicInfo = ({
  addContentModule,
  addGallery,
  addNewCategoryPill,
  addNewPriceCard,
  addNewFAQ,
  addNewFAQImage,
  addNewContentCardPill,
  addNewLink,
  addNewMarketingPill,
  addNewMarketingModule,
  addNewMediaIcon,
  addSuitesCardModule,
  allSuiteLevels,
  deleteAllCategoryPills,
  deleteAllContentCards,
  deleteAllGallery,
  deleteAllLink,
  deleteAllPriceCards,
  deleteAllMarketingPills,
  deleteAllMediaIcon,
  deleteContentModule,
  deleteAllMarketingModules,
  deleteGallery,
  deleteMediaRow,
  deleteAllFAQs,
  deleteAllFAQsImages,
  deleteSuitesCardModule,
  galleries,
  gallery_header,
  handleAddCta,
  handleAddUniversalModule,
  handleAllEventsChange,
  handleAutoplay,
  handleButtonTextUpdate,
  handleCalendarDescriptionChange,
  handleCalendarTitleChange,
  handleChatPopUpIdChange,
  handlePopularSearchesChange,
  handleCategoryPills,
  handleConcessionDisclaimerChange,
  handleConcessionFeaturedVendorChange,
  handleConcessionFoodAndDrinkChange,
  handleConcessionHeroBannerChange,
  handleConcessionMediaCarouselChange,
  handleConcessionPromotionalVideoChange,
  handleConcessionVendorGridChange,
  handleConcessionVenuePartnerBenefitsChange,
  handleContentCard,
  handleContentCardSectionHeaderChange,
  handleContentModuleContentChange,
  handlePriceCardDisclaimerChange,
  handleFAQsSectionHeaderChange,
  handleOverviewSectionHeaderChange,
  handleOverviewDescriptionChange,
  handlePriceCard,
  handlePriceCardSectionHeaderChange,
  handleContentModuleCTANameChange,
  handleContentModuleCTAUrlChange,
  handleContentModuleHeaderChange,
  handleContentModuleImageUrlUpdate,
  handleCTAHrefChange,
  handleCTATitleChange,
  handleDeleteCta,
  handleDeleteUniversalModule,
  handleExpiresAtChange,
  handleFAQs,
  handleFAQAttending,
  handleFAQHeroImageUpload,
  handleFAQHeroTitleChange,
  handleFAQPageSections,
  handleFlockler,
  handleFormModuleDescriptionChange,
  handleFormModuleDisclaimerChange,
  handleFormModuleHeaderChange,
  handleFormModuleIdUpdate,
  handleFormModuleMessageChange,
  handleFormModuleSuccessSubmitButtonTextUpdate,
  handleFormModuleTitleChange,
  handleGalleryChange,
  handleGalleryImageAltChange,
  handleGalleryImageUrlUpdate,
  handleGalleryMediaChange,
  handleGallerySubTitleChange,
  handleGalleryTitleChange,
  handleHeroButtonLabelChange,
  handleHeroChatLabelChange,
  handleHeroDescriptionChange,
  handleHeroEmailChange,
  handleHeroFormIdChange,
  handleHeroImageUrlUpdate,
  handleHeroPhoneNumberChange,
  handleHeroSubTitleChange,
  handleHeroTitleChange,
  handleHorizontalBanner,
  handleImageChange,
  handleImageUrlChange,
  handleMarketingPills,
  handleMediaRow,
  handlePageMetaDescriptionChange,
  handlePageMetaHeadingChange,
  handlePageMetaKeywordsChange,
  handlePageMetaShowSEOChange,
  handlePageMetaTextChange,
  handlePageMetaTitleChange,
  handlePageNameChange,
  handlePageSubtypeChange,
  handlePageTypeChange,
  handleRecommendationSectionTitle,
  handleSearchTagsChange,
  handleSelectedEventsChange,
  handleShowCalendar,
  handleSlugChange,
  handleSuiteAmenitiesChange,
  handleSuiteCapacityChange,
  handleSuiteCardShortNameChange,
  handleSuiteCardTypeChange,
  handleSuiteCTAUpdate,
  handleSuiteEventIdeasChange,
  handleSuiteEventTypeChange,
  handleSuiteFormStatus,
  handleSuiteHospitalityChange,
  handleSuiteLogoUpload,
  handleSuiteSizeChange,
  handleGallerySectionTitle,
  handleSuiteSubTitleChange,
  handleSuiteTitleChange,
  handleTourPlanDescriptionChange,
  handleEvergreenChange,
  handleShowInGoogleSearchChange,
  handleShowInInternalSearchChange,
  handleUniversalModuleReorder,
  handleUniversalModuleUpdate,
  universalTemplateErrors = {},
  concessionErrors = {},
  showConcessionValidationErrors = false,
  handleUpcomingShowsSectionTitle,
  handleVenueChange,
  handleVenueRentalsHeroChange,
  mode,
  page,
  pageTypes,
  recommendedEvents,
  selectedType,
  setMarketingModules,
  setAnchorLinks,
  setGallery,
  setVLPHeroAllEvents,
  setVLPHeroPromotedEvents,
  reorderVLPHeroPromotedEvents,
  suitesAmenities,
  suitesCapacity,
  suitesEventIdeas,
  suitesEventType,
  suitesHospitality,
  suitesSize,
  todaysEvent,
  tourVenues,
  upcomingEvents,
  venues,
  vlpHeroAllEvents,
  vlpHeroPromotedEvents
}) => {
  React.useEffect(() => {
    if (page?.type !== 'universal-template' || typeof handleSlugChange !== 'function') return
    const slug = page?.slug
    if (!slug || typeof slug !== 'string') return
    if (isValidUniversalTemplateSlug(slug, page?.subtype)) return
    const suffix = getUniversalTemplateSlugSuffix(slug, page?.subtype)
    if (!suffix || !UNIVERSAL_TEMPLATE_SLUG_SUFFIX_RE.test(suffix)) return
    const canonical = `${getUniversalTemplateSlugPrefix(page?.subtype)}${suffix}`
    if (slug === canonical) return
    handleSlugChange({ target: { value: canonical } })
    // Intentionally omit handleSlugChange: parent often passes an inline handler and would retrigger every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page?.type, page?.slug, page?.subtype])

  React.useEffect(() => {
    if (page?.type !== 'faq' || typeof handleSlugChange !== 'function') return
    const faqVenueForEffect = venues?.find(v => String(v._id) === String(page?.venue_id))
    if (!faqVenueForEffect?.name) return
    const slug = page?.slug
    if (!slug || typeof slug !== 'string') return
    if (isValidFaqSlug(slug, faqVenueForEffect.name)) return
    const suffix = getFaqSlugSuffix(slug, faqVenueForEffect.name)
    if (!suffix || !FAQ_SLUG_SUFFIX_RE.test(suffix)) return
    const canonical = `${getFaqSlugPrefix(faqVenueForEffect.name)}${suffix}`
    if (slug === canonical) return
    handleSlugChange({ target: { value: canonical } })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page?.type, page?.slug, page?.venue_id, venues])

  React.useEffect(() => {
    if (page?.type !== 'concession' || typeof handleSlugChange !== 'function') return
    const concessionVenueForEffect = venues?.find(v => String(v._id) === String(page?.venue_id))
    if (!concessionVenueForEffect?.name) return
    const canonical = buildConcessionSlugFromVenue(concessionVenueForEffect.name)
    if (!canonical || page?.slug === canonical) return
    handleSlugChange({ target: { value: canonical } })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page?.type, page?.slug, page?.venue_id, venues])

  React.useEffect(() => {
    if (page?.type !== VENUE_RENTALS_PAGE_TYPE || typeof handleSlugChange !== 'function') return
    const venueRentalsVenueForEffect = venues?.find(v => String(v._id) === String(page?.venue_id))
    if (!venueRentalsVenueForEffect?.name) return
    const canonical = buildVenueRentalsSlugFromVenue(venueRentalsVenueForEffect.name)
    if (!canonical || page?.slug === canonical) return
    handleSlugChange({ target: { value: canonical } })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page?.type, page?.slug, page?.venue_id, venues])

  const addMediaRow = <Button className={styles.updateActionButton} onClick={addNewMediaIcon} type='primary'>
    Add Media Row
  </Button>

  const deleteAllMediaRow = page?.media_row?.length > 0 && <Button className={styles.deleteActionButton} onClick={deleteAllMediaIcon} style={{ backgroundColor: '#DA0D50', color: '#fff' }} type='danger'>
    Delete All
  </Button>

  const addCategoryMarketingPill = <Button className={styles.updateActionButton} onClick={addNewCategoryPill} type='primary'>
    Add Pill
  </Button>

  const deleteAllCategoryMarketingPill = page?.category_pills?.length > 0 && <Button className={styles.deleteActionButton} onClick={deleteAllCategoryPills} style={{ backgroundColor: '#DA0D50', color: '#fff' }} type='danger'>
    Delete All
  </Button>

  const addNavLink = <Button className={styles.updateActionButton} onClick={addNewLink} type='primary'>
  Add Nav Link
  </Button>

  const deleteAllNavLink = page?.anchor_links?.length > 0 && <Button className={styles.deleteActionButton} onClick={deleteAllLink} style={{ backgroundColor: '#DA0D50', color: '#fff' }} type='danger'>
  Delete All
  </Button>

  const addMarketingPill = <Button className={styles.updateActionButton} onClick={addNewMarketingPill} type='primary'>
    Add Pill
  </Button>

  const deleteAllMarketingPill = page?.marketing_pills?.length > 0 && <Button className={styles.deleteActionButton} onClick={deleteAllMarketingPills} style={{ backgroundColor: '#DA0D50', color: '#fff' }} type='danger'>
    Delete All
  </Button>

  const addMContentCardPill = <Button className={styles.updateActionButton} onClick={addNewContentCardPill} type='primary'>
    Add Content Card
  </Button>
  const addMarketingModule = <Button className={styles.updateActionButton} onClick={addNewMarketingModule} type='primary'>
    Add Marketing Module
  </Button>
  const heroAutoPlay = <Checkbox checked={page?.hero?.autoplay} isInline label={<Title level={3}>AutoScroll</Title>} onChange={handleAutoplay}/>
  const deleteAllContentCardsPill = page?.marketing_pills?.length > 0 && <Button className={styles.deleteActionButton} onClick={deleteAllContentCards} style={{ backgroundColor: '#DA0D50', color: '#fff' }} type='danger'>
    Delete All
  </Button>
  const deleteMarketingModules = page?.marketing_pills?.length > 0 && <Button className={styles.deleteActionButton} onClick={deleteAllMarketingModules} style={{ backgroundColor: '#DA0D50', color: '#fff' }} type='danger'>
    Delete All
  </Button>
  const slugUrl = (REACT_APP_STAGE === 'production') ? `${VLP_BASE_URL.PROD}${page?.slug}` : `${VLP_BASE_URL.NON_PROD}${page?.slug}`

  const isUniversalTemplate = page?.type === 'universal-template'
  const isFaq = page?.type === 'faq'
  const isConcession = page?.type === 'concession'
  const isVenueRentals = page?.type === VENUE_RENTALS_PAGE_TYPE
  const selectedVenue = (isUniversalTemplate || isFaq || isConcession || isVenueRentals) && venues
    ? venues.find(v => String(v._id) === String(page?.venue_id))
    : null
  const venueTimezone = selectedVenue?.timezone || 'America/New_York'
  const venueSlugPrefix = getUniversalTemplateSlugPrefix(page?.subtype)
  const universalSlugSuffix = isUniversalTemplate ? getUniversalTemplateSlugSuffix(page?.slug, page?.subtype) : ''
  const concessionSlugPrefix = isConcession && selectedVenue ? getFaqSlugPrefix(selectedVenue.name) : ''
  const concessionFullSlug = isConcession && selectedVenue
    ? buildConcessionSlugFromVenue(selectedVenue.name)
    : ''
  const faqSlugPrefix = isFaq && selectedVenue ? getFaqSlugPrefix(selectedVenue.name) : ''
  const faqSlugSuffix = isFaq && selectedVenue ? getFaqSlugSuffix(page?.slug, selectedVenue.name) : ''
  const slugError = isUniversalTemplate && universalSlugSuffix && !UNIVERSAL_TEMPLATE_SLUG_SUFFIX_RE.test(universalSlugSuffix)
    ? 'Only lowercase letters (a–z), numbers, and hyphens are allowed. Must start with a letter or number.'
    : null
  const venueRentalsSlugPrefix = isVenueRentals && selectedVenue ? getFaqSlugPrefix(selectedVenue.name) : ''
  const venueRentalsFullSlug = isVenueRentals && selectedVenue
    ? buildVenueRentalsSlugFromVenue(selectedVenue.name)
    : ''
  const concessionSlugError = isConcession && selectedVenue?.name && page?.slug && !isValidConcessionSlug(page?.slug, selectedVenue.name)
    ? `Slug must be ${concessionSlugPrefix}${CONCESSION_SLUG_SUFFIX}`
    : null
  const venueRentalsSlugError = isVenueRentals && selectedVenue?.name && page?.slug && !isValidVenueRentalsSlug(page?.slug, selectedVenue.name)
    ? `Slug must be ${venueRentalsSlugPrefix}${VENUE_RENTALS_SLUG_SUFFIX}`
    : null
  const hasVenueRentalsBasics = isVenueRentals &&
    Boolean(String(page?.name ?? '').trim()) &&
    Boolean(page?.venue_id) &&
    Boolean(selectedVenue)
  const faqSlugError = isFaq && faqSlugSuffix && faqSlugPrefix && !FAQ_SLUG_SUFFIX_RE.test(faqSlugSuffix)
    ? 'Only lowercase letters (a–z), numbers, and hyphens are allowed. Must start with a letter or number.'
    : null

  const showCalendar = <Checkbox checked={page?.calendar?.show_calendar} isInline label={<Title level={3}>Show Calendar</Title>} onChange={handleShowCalendar}/>

  const addNewGallery = galleries && galleries?.length < 10 ? <Button className={styles.updateActionButton} onClick={addGallery} type='primary'>
    Add Gallery
  </Button> : null

  const deleteAllGalleryItems = galleries && galleries?.length > 0 ? <Button className={styles.deleteActionButton} onClick={deleteAllGallery} type='danger'>
    Delete All
  </Button> : null

  const addPriceCard = <Button className={styles.updateActionButton} onClick={addNewPriceCard} type='primary'>
    Add Price Card
  </Button>

  const deleteAllPriceCard = page?.marketing_pills?.length > 0 && <Button className={styles.deleteActionButton} onClick={deleteAllPriceCards} style={{ backgroundColor: '#DA0D50', color: '#fff' }} type='danger'>
    Delete All
  </Button>

  const addFAQModule = <Button className={styles.updateActionButton} onClick={addNewFAQ} type='primary'>
    Add FAQ
  </Button>

  const deleteAllFAQModules = page?.faqs?.flex_modules?.length > 0 && <Button className={styles.deleteActionButton} onClick={deleteAllFAQs} style={{ backgroundColor: '#DA0D50', color: '#fff' }} type='danger'>
    Delete All
  </Button>

  const popularSearchesSection =
    page?.venue_id && !isUniversalTemplate && !isFaq && !isConcession && !isVenueRentals && typeof handlePopularSearchesChange === 'function' ? (
      <div style={{ padding: '8px 0 16px' }}>
        <PopularSearchesSection
          onChange={handlePopularSearchesChange}
          pills={page?.popular_searches || []}
          venueSlug={venues?.find(v => String(v._id) === String(page?.venue_id))?.slug}
        />
        <Divider style={{ margin: '16px 0' }} />
      </div>
    ) : null

  const satisfiChatbotModalIdSection =
    typeof handleChatPopUpIdChange === 'function' && (!isVenueRentals || hasVenueRentalsBasics) ? (
      <div
        style={{
          // Match venue→slug rhythm: Divider uses margin 16px 0 (≈32px between blocks).
          padding: (isUniversalTemplate || isConcession || isVenueRentals) ? '32px 0 16px' : '8px 0 16px'
        }}
      >
        <h3 style={{ marginBottom: 8, fontWeight: 400, fontSize: 20 }}>Satisfi Chatbot Modal ID</h3>
        <Input
          disabled={!page?.show_chatbot}
          onChange={handleChatPopUpIdChange}
          placeholder="Satisfi Modal ID"
          style={{ width: 240 }}
          value={page?.chat_pop_up_id ?? ''}
        />
      </div>
    ) : null

  const searchVisibilitySection =
    page?.type &&
    typeof handleShowInGoogleSearchChange === 'function' &&
    typeof handleShowInInternalSearchChange === 'function' &&
    (!isVenueRentals || hasVenueRentalsBasics) ? (
        <>
          <Divider style={{ margin: '16px 0' }} />
          <Row gutter={32} style={{ marginBottom: 16 }}>
            <Col>
              <Checkbox
                checked={page?.show_in_internal_search ?? true}
                label='Show in MSG Internal Search'
                onChange={handleShowInInternalSearchChange}
              />
            </Col>
            <Col>
              <Checkbox
                checked={page?.show_in_google_search ?? true}
                label='Show in Google Search'
                onChange={handleShowInGoogleSearchChange}
              />
            </Col>
          </Row>
        </>
      ) : null

  const nameError = universalTemplateErrors.name || concessionErrors.name

  return (
    <Card>
      <Row>
        <Col xl={24} xs={24}>
          <Row align={'middle'} className={styles['title-wrapper']}>
            <Col>
              <Title
                className={nameError ? styles.universalMandatoryTitle : undefined}
                level={3}
              >
                Name
              </Title>
            </Col>
          </Row>
          <div className={nameError ? styles.universalMandatoryControlRing : undefined}>
            <Input {
              ...(mode === 'edit') && {
                disabled: true
              }
            } onChange={handlePageNameChange} value={page?.name} />
          </div>
          {nameError && (
            <Typography.Text className={styles.universalTemplateValidationErrorName}>{nameError}</Typography.Text>
          )}
        </Col>
        {pageTypes && <Col xl={24} xs={24}>
          <MultiSelectDropdown
            allowClear={true}
            displayField='label'
            {
              ...(mode === 'edit') && {
                disabled: true
              }
            }
            dropdownOptions={pageTypes}
            handleChange={handlePageTypeChange}
            label={<Title level={3}>Type</Title>}
            selectedItems={page?.type || selectedType}
            valueField='value'
          /><br />
        </Col>}
        {isUniversalTemplate && (
          <Col style={{ paddingTop: 12 }} xl={24} xs={24}>
            <Title level={3}>Subtype</Title>
            <Select
              disabled
              onChange={handlePageSubtypeChange}
              style={{ width: 450 }}
              value={page?.subtype || 'sweepstakes'}
            >
              <Select.Option key="sweepstakes" value="sweepstakes">Sweepstakes</Select.Option>
            </Select>
          </Col>
        )}
        {isUniversalTemplate && <Col xl={24} xs={24}><Divider style={{ margin: '16px 0' }} /></Col>}
        {isUniversalTemplate && venues && (
          <Col xl={24} xs={24}>
            <div className={universalTemplateErrors.venueId ? styles.universalMandatoryControlRing : undefined}>
              <MultiSelectDropdown
                allowClear
                customStyle={{ width: 450 }}
                displayField='name'
                dropdownOptions={venues}
                handleChange={handleVenueChange}
                label={(
                  <Title
                    className={universalTemplateErrors.venueId ? styles.universalMandatoryTitle : undefined}
                    level={3}
                  >
                    Venue
                  </Title>
                )}
                selectedItems={page?.venue_id}
                valueField='_id'
              />
            </div>
            {universalTemplateErrors.venueId && (
              <Typography.Text className={styles.universalTemplateValidationError}>{universalTemplateErrors.venueId}</Typography.Text>
            )}
          </Col>
        )}
        {isUniversalTemplate && <Col xl={24} xs={24}><Divider style={{ margin: '16px 0' }} /></Col>}
        {isConcession && venues && (
          <Col xl={24} xs={24}>
            <div className={concessionErrors.venueId ? styles.universalMandatoryControlRing : undefined}>
              <MultiSelectDropdown
                {...(mode === 'edit' ? { disabled: true } : null)}
                allowClear
                customStyle={{ width: 450 }}
                displayField='name'
                dropdownOptions={venues}
                handleChange={handleVenueChange}
                label={(
                  <Title
                    className={concessionErrors.venueId ? styles.universalMandatoryTitle : undefined}
                    level={3}
                  >
                    Venue*
                  </Title>
                )}
                selectedItems={page?.venue_id}
                valueField='_id'
              />
            </div>
            {concessionErrors.venueId && (
              <Typography.Text className={styles.universalTemplateValidationError}>{concessionErrors.venueId}</Typography.Text>
            )}
          </Col>
        )}
        {isConcession && <Col xl={24} xs={24}><Divider style={{ margin: '16px 0' }} /></Col>}
        {isVenueRentals && venues && (
          <Col xl={24} xs={24}>
            <div className={concessionErrors.venueId ? styles.universalMandatoryControlRing : undefined}>
              <MultiSelectDropdown
                {...(mode === 'edit' ? { disabled: true } : null)}
                allowClear
                customStyle={{ width: 450 }}
                displayField='name'
                dropdownOptions={venues}
                handleChange={handleVenueChange}
                label={(
                  <Title
                    className={concessionErrors.venueId ? styles.universalMandatoryTitle : undefined}
                    level={3}
                  >
                    Venue*
                  </Title>
                )}
                selectedItems={page?.venue_id}
                valueField='_id'
              />
            </div>
            {concessionErrors.venueId && (
              <Typography.Text className={styles.universalTemplateValidationError}>{concessionErrors.venueId}</Typography.Text>
            )}
          </Col>
        )}
        {isVenueRentals && hasVenueRentalsBasics && <Col xl={24} xs={24}><Divider style={{ margin: '16px 0' }} /></Col>}
        {(!isVenueRentals || hasVenueRentalsBasics) && (
          <Col style={{ marginTop: (isUniversalTemplate || isConcession || isVenueRentals) ? 0 : 16 }} xl={24} xs={24}>
            <Row align={'middle'} className={styles['title-wrapper']}>
              <Col>
                <Title
                  className={
                    (isUniversalTemplate && (slugError || universalTemplateErrors.slug)) ||
                  (isConcession && (concessionSlugError || concessionErrors.slug)) ||
                  (isVenueRentals && venueRentalsSlugError)
                      ? styles.universalMandatoryTitle
                      : undefined
                  }
                  level={3}
                >
                Slug*{' '}
                </Title>
              </Col>
              <Col>&nbsp;&nbsp;<a href={slugUrl} rel='noreferrer' target='_blank'><LinkOutlined /></a></Col>
            </Row>
            {isUniversalTemplate ? (
              <div className={(slugError || universalTemplateErrors.slug) ? styles.universalMandatoryControlRing : undefined}>
                <AntdInput
                  addonBefore={venueSlugPrefix}
                  onChange={e => {
                    const rawInput = e.target.value
                      .replace(/^\/+/, '')
                      .toLowerCase()
                      .replace(/\s+/g, '-')
                    const raw = getUniversalTemplateSlugSuffix(rawInput, page?.subtype)
                    handleSlugChange({ target: { value: raw ? `${venueSlugPrefix}${raw}` : '' } })
                  }}
                  placeholder="my-sweepstakes-page"
                  status={(slugError || universalTemplateErrors.slug) ? 'error' : undefined}
                  value={universalSlugSuffix}
                />
                {(slugError || universalTemplateErrors.slug)
                  ? <Typography.Text className={styles.universalTemplateValidationError}>{slugError || universalTemplateErrors.slug}</Typography.Text>
                  : <Typography.Text style={{ color: '#8c8c8c', display: 'block', fontSize: 12, marginTop: 4 }}>
                  Full slug: <strong>{venueSlugPrefix}{universalSlugSuffix || '…'}</strong> · Only lowercase letters, numbers, and hyphens
                  </Typography.Text>
                }
              </div>
            ) : isConcession && concessionSlugPrefix ? (
              <div className={(concessionSlugError || concessionErrors.slug) ? styles.universalMandatoryControlRing : undefined}>
                <AntdInput
                  addonBefore={concessionSlugPrefix}
                  disabled
                  placeholder={CONCESSION_SLUG_SUFFIX}
                  status={(concessionSlugError || concessionErrors.slug) ? 'error' : undefined}
                  value={CONCESSION_SLUG_SUFFIX}
                />
                {(concessionSlugError || concessionErrors.slug)
                  ? <Typography.Text className={styles.universalTemplateValidationError}>{concessionSlugError || concessionErrors.slug}</Typography.Text>
                  : <Typography.Text style={{ color: '#8c8c8c', display: 'block', fontSize: 12, marginTop: 4 }}>
                  Full slug: <strong>{concessionFullSlug || '…'}</strong>
                  </Typography.Text>
                }
              </div>
            ) : isConcession ? (
              <Typography.Text style={{ color: '#8c8c8c', display: 'block', fontSize: 12 }}>
                Select a venue above to generate the slug prefix from the venue name.
              </Typography.Text>
            ) : isVenueRentals && venueRentalsSlugPrefix ? (
              <div className={venueRentalsSlugError ? styles.universalMandatoryControlRing : undefined}>
                <AntdInput
                  addonBefore={venueRentalsSlugPrefix}
                  disabled
                  placeholder={VENUE_RENTALS_SLUG_SUFFIX}
                  status={venueRentalsSlugError ? 'error' : undefined}
                  value={VENUE_RENTALS_SLUG_SUFFIX}
                />
                {venueRentalsSlugError
                  ? <Typography.Text className={styles.universalTemplateValidationError}>{venueRentalsSlugError}</Typography.Text>
                  : <Typography.Text style={{ color: '#8c8c8c', display: 'block', fontSize: 12, marginTop: 4 }}>
                  Full slug: <strong>{venueRentalsFullSlug || '…'}</strong>
                  </Typography.Text>
                }
              </div>
            ) : isVenueRentals ? (
              <Typography.Text style={{ color: '#8c8c8c', display: 'block', fontSize: 12 }}>
                Select a venue above to generate the slug prefix from the venue name.
              </Typography.Text>
            ) : isFaq && faqSlugPrefix ? (
              <div className={faqSlugError ? styles.universalMandatoryControlRing : undefined}>
                <AntdInput
                  addonBefore={faqSlugPrefix}
                  onChange={e => {
                    const rawInput = e.target.value
                      .replace(/^\/+/, '')
                      .toLowerCase()
                      .replace(/\s+/g, '-')
                    const raw = getFaqSlugSuffix(rawInput, selectedVenue?.name)
                    handleSlugChange({ target: { value: raw ? `${faqSlugPrefix}${raw}` : '' } })
                  }}
                  placeholder="faqs"
                  status={faqSlugError ? 'error' : undefined}
                  value={faqSlugSuffix}
                />
                {faqSlugError
                  ? <Typography.Text className={styles.universalTemplateValidationError}>{faqSlugError}</Typography.Text>
                  : <Typography.Text style={{ color: '#8c8c8c', display: 'block', fontSize: 12, marginTop: 4 }}>
                  Full slug: <strong>{faqSlugPrefix}{faqSlugSuffix || '…'}</strong> · Only lowercase letters, numbers, and hyphens
                  </Typography.Text>
                }
              </div>
            ) : isFaq ? (
              <Typography.Text style={{ color: '#8c8c8c', display: 'block', fontSize: 12 }}>
              Select a venue below to generate the slug prefix from the venue name.
              </Typography.Text>
            ) : (
              <Input {
                ...(mode === 'edit') && {
                  disabled: true
                }
              } onChange={handleSlugChange} value={page?.slug} />
            )}
          </Col>
        )}
      </Row>
      {popularSearchesSection}
      {satisfiChatbotModalIdSection}
      {searchVisibilitySection}
      {hasVenueRentalsBasics && typeof handleVenueRentalsHeroChange === 'function' && (
        <VenueRentalsHeroFields
          hero={page?.venue_rentals_hero}
          heroErrors={concessionErrors?.hero}
          onChange={handleVenueRentalsHeroChange}
          showValidationErrors={showConcessionValidationErrors}
        />
      )}
      {!isVenueRentals && (
        <>
          {page?.type === 'universal-template' && (
            <>
              {typeof handleSearchTagsChange === 'function' && (
                <div style={{ marginBottom: 16 }}>
                  <InternalSearchOptimization
                    setTags={handleSearchTagsChange}
                    tags={page?.search_tags || []}
                  />
                </div>
              )}
              <Row gutter={32} style={{ marginBottom: 16 }}>
                <Col>
                  <Checkbox
                    checked={page?.is_evergreen ?? false}
                    label='Evergreen (Never Expire)'
                    onChange={handleEvergreenChange}
                  />
                </Col>
              </Row>
              {!page?.is_evergreen && (
                <Row>
                  <Col xl={24} xs={24}>
                    <div className={universalTemplateErrors.pageExpiresAt ? styles.universalMandatoryControlRing : undefined}>
                      <DatePicker
                        allowClear={false}
                        disabledDate={disabledExpiryDate(venueTimezone)}
                        disabledTime={disabledExpiryTime(venueTimezone)}
                        format="YYYY-MM-DD h:mm A"
                        label={`Page Expiry Time (${moment.tz(venueTimezone).zoneAbbr()}) *`}
                        labelClassName={universalTemplateErrors.pageExpiresAt ? styles.universalMandatoryPageExpiryLabel : undefined}
                        onChange={handleExpiresAtChange}
                        showTime
                        value={page?.expires_at ? moment(page.expires_at).tz(venueTimezone) : null}
                      />
                    </div>
                    {universalTemplateErrors.pageExpiresAt && (
                      <Typography.Text className={styles.universalTemplateValidationError}>{universalTemplateErrors.pageExpiresAt}</Typography.Text>
                    )}
                    <Typography.Text style={{ color: '#8c8c8c', display: 'block', fontSize: 12, marginTop: 4 }}>
                  Timezone: {venueTimezone}
                    </Typography.Text>
                  </Col>
                </Row>
              )}
              {isUniversalTemplate && (
                <UniversalTemplateModules
                  customFieldsError={universalTemplateErrors.formCustomFields}
                  expiresAtError={universalTemplateErrors.expiresAt}
                  formUrlError={universalTemplateErrors.formUrl}
                  modules={page?.modules || []}
                  modulesError={universalTemplateErrors.modules}
                  onAddModule={handleAddUniversalModule}
                  onDeleteModule={handleDeleteUniversalModule}
                  onReorderModule={handleUniversalModuleReorder}
                  onUpdateModule={handleUniversalModuleUpdate}
                  venueTimezone={venueTimezone}
                />
              )}
            </>
          )}
          {(isUniversalTemplate || isConcession) && (
            <>
              {isConcession && typeof handleConcessionHeroBannerChange === 'function' && (
                <ConcessionPageSections
                  concessionErrors={concessionErrors}
                  onDisclaimerChange={handleConcessionDisclaimerChange}
                  onFeaturedVendorChange={handleConcessionFeaturedVendorChange}
                  onFoodAndDrinkChange={handleConcessionFoodAndDrinkChange}
                  onHeroBannerChange={handleConcessionHeroBannerChange}
                  onMediaCarouselChange={handleConcessionMediaCarouselChange}
                  onPromotionalVideoChange={handleConcessionPromotionalVideoChange}
                  onVendorGridChange={handleConcessionVendorGridChange}
                  onVenuePartnerBenefitsChange={handleConcessionVenuePartnerBenefitsChange}
                  page={page}
                  showConcessionValidationErrors={showConcessionValidationErrors}
                  venues={venues}
                />
              )}
              <Collapse accordion expandIconPosition='right' style={{ marginTop: 16 }}>
                <Panel key='page-meta' header='Page Meta' style={{ fontSize: 20 }}>
                  <Card style={{ borderColor: '#3642b1' }}>
                    <PageMetaInfo
                      handleDescriptionChange={handlePageMetaDescriptionChange}
                      handleHeadingChange={handlePageMetaHeadingChange}
                      handleKeywordsChange={handlePageMetaKeywordsChange}
                      handleShowSEOChange={handlePageMetaShowSEOChange}
                      handleTextChange={handlePageMetaTextChange}
                      handleTitleChange={handlePageMetaTitleChange}
                      pageMeta={page?.page_meta || {}}
                    />
                  </Card>
                </Panel>
              </Collapse>
            </>
          )}
          {
            PAGE_TYPES_PREMIUM_EDITOR.includes(page?.type) &&
          <Collapse accordion defaultActiveKey={['0']} expandIconPosition='right'>
            <Panel key='1' header='Hero' style={{
              fontSize: 20
            }}>
              <Card style={{ borderColor: '#3642b1' }}>
                <HeroBasicInfo
                  handleButtonLabelChange={handleHeroButtonLabelChange}
                  handleChatLabelChange={handleHeroChatLabelChange}
                  handleContentChange={handleHeroDescriptionChange}
                  handleEmailChange={handleHeroEmailChange}
                  handleFormIdChange={handleHeroFormIdChange}
                  handleImageChange={handleImageChange}
                  handleImageUrlChange={handleImageUrlChange}
                  handleImageUrlUpdate={handleHeroImageUrlUpdate}
                  handlePhoneNumberChange={handleHeroPhoneNumberChange}
                  handleSubTitleChange={handleHeroSubTitleChange}
                  handleTitleChange={handleHeroTitleChange}
                  hero={page?.hero || {}}
                  pageType={page?.type || 'premium-hospitality'}
                />
              </Card>
            </Panel>
            <Panel key='2'
              extra={
                <div onClick={addContentModule}><Tooltip title='Add new content module'>
                  <Button icon={<PlusOutlined />} />
                </Tooltip>
                </div>
              }
              header='Content Modules'
              style={{
                fontSize: 20
              }}
            >
              {page?.content_modules && <Card style={{ borderColor: '#3f6600' }}><Collapse accordion defaultActiveKey={['0']} expandIconPosition='right'>
                {
                  page?.content_modules.map((contentModule, index) => <Panel
                    key={index}
                    extra={
                      <div onClick={(event) => deleteContentModule(event, index)}><Tooltip title='Delete module'>
                        <Button danger icon={<DeleteFilled />} />
                      </Tooltip>
                      </div>
                    }
                    header={contentModule?.header}
                    style={{
                      fontSize: 20
                    }}
                  >
                    <ContentModuleBasicInfo
                      key={index}
                      contentIndex={index}
                      contentModule={contentModule}
                      handleCTANameChange={handleContentModuleCTANameChange}
                      handleCTAUrlChange={handleContentModuleCTAUrlChange}
                      handleContentChange={handleContentModuleContentChange}
                      handleHeaderChange={handleContentModuleHeaderChange}
                      handleImageUrlUpdate={handleContentModuleImageUrlUpdate}
                    />
                  </Panel>
                  )
                }</Collapse>
              </Card>}
            </Panel>
            <Panel key='3' header='Page Meta' style={{
              fontSize: 20
            }}>
              <Card style={{ borderColor: '#3642b1' }}>
                <PageMetaInfo
                  handleDescriptionChange={handlePageMetaDescriptionChange}
                  handleHeadingChange={handlePageMetaHeadingChange}
                  handleKeywordsChange={handlePageMetaKeywordsChange}
                  handleShowSEOChange={handlePageMetaShowSEOChange}
                  handleTextChange={handlePageMetaTextChange}
                  handleTitleChange={handlePageMetaTitleChange}
                  pageMeta={page?.page_meta || {}}
                />
              </Card>
            </Panel>
            <Panel key='4' header='Form' style={{
              fontSize: 20
            }}>
              <Card>
                <PageForm
                  form={page?.form || {}}
                  handleButtonTextUpdate={handleButtonTextUpdate}
                  handleDescriptionChange={handleFormModuleDescriptionChange}
                  handleDisclaimerChange={handleFormModuleDisclaimerChange}
                  handleFormIdUpdate={handleFormModuleIdUpdate}
                  handleHeaderChange={handleFormModuleHeaderChange}
                  handleMessageChange={handleFormModuleMessageChange}
                  handleSuccessSubmitButtonUpdate={handleFormModuleSuccessSubmitButtonTextUpdate}
                  handleTitleChange={handleFormModuleTitleChange}
                />
              </Card>
            </Panel>
            <Panel key='5'
              extra={
                <div onClick={addSuitesCardModule}><Tooltip title='Add new card'>
                  <Button icon={<PlusOutlined />} />
                </Tooltip>
                </div>
              }
              header='Cards'
              style={{
                fontSize: 20
              }}>
              {page?.cards && <Card style={{ borderColor: '#d46b08' }}><Collapse accordion defaultActiveKey={['0']} expandIconPosition='right'>
                {
                  page?.cards.map((suiteCard, suiteIndex) => <Panel key={suiteIndex}
                    extra={
                      <div onClick={(event) => deleteSuitesCardModule(event, suiteIndex)}><Tooltip title='Delete card'>
                        <Button danger icon={<DeleteFilled />} />
                      </Tooltip>
                      </div>
                    }
                    header={suiteCard?.title}
                    style={{
                      fontSize: 20
                    }}
                  >
                    <SuiteCardBasicInfo
                      key={suiteIndex}
                      allSuiteLevels={allSuiteLevels}
                      handleAddCta={handleAddCta}
                      handleAllEventsChange={handleAllEventsChange}
                      handleAmenitiesChange={handleSuiteAmenitiesChange}
                      handleCTAHrefChange={handleCTAHrefChange}
                      handleCTATitleChange={handleCTATitleChange}
                      handleCTAUpdate={handleSuiteCTAUpdate}
                      handleCapacityChange={handleSuiteCapacityChange}
                      handleDeleteCta={handleDeleteCta}
                      handleEventIdeasChange={handleSuiteEventIdeasChange}
                      handleEventTypeChange={handleSuiteEventTypeChange}
                      handleFormStatus={handleSuiteFormStatus}
                      handleHospitalityChange={handleSuiteHospitalityChange}
                      handleImageUrlUpdate={handleSuiteLogoUpload}
                      handleSelectedEventsChange={handleSelectedEventsChange}
                      handleSizeChange={handleSuiteSizeChange}
                      handleSubTitleChange={handleSuiteSubTitleChange}
                      handleSuiteCardShortNameChange={handleSuiteCardShortNameChange}
                      handleSuiteCardTypeChange={handleSuiteCardTypeChange}
                      handleTitleChange={handleSuiteTitleChange}
                      suiteCard={suiteCard}
                      suiteIndex={suiteIndex}
                      suitesAmenities={suitesAmenities}
                      suitesCapacity={suitesCapacity}
                      suitesEventIdeas={suitesEventIdeas}
                      suitesEventType={suitesEventType}
                      suitesHospitality={suitesHospitality}
                      suitesSize={suitesSize}
                    />
                  </Panel>
                  )
                }</Collapse>
              </Card>}
            </Panel>
          </Collapse>
          }
          {
            page?.type === 'venue-landing' && <><Row>
              {venues && <Col xl={24} xs={24}>
                <MultiSelectDropdown
                  {...(mode === 'edit' ? { disabled: true } : null)}
                  allowClear={true}
                  customStyle={{ width: 450 }}
                  displayField='name'
                  dropdownOptions={venues}
                  handleChange={handleVenueChange}
                  label={<Title level={3}>Venue*</Title>}
                  selectedItems={page?.venue_id}
                  valueField='_id'
                /><br />
              </Col>}
            </Row>
            {
              page?.venue_id && <Collapse accordion defaultActiveKey={['0']} expandIconPosition='right'>
                <Panel key='1' extra={[heroAutoPlay]} header='Hero' style={{
                  fontSize: 20
                }}>
                  <Card style={{ borderColor: '#3642b1' }}>
                    {todaysEvent && <><Title level={3}>Today/Tonight Event</Title><Table columns={todaysEventColumns} dataSource={[todaysEvent]} pagination={false} /><br />
                      <hr />
                      <br />
                    </>}
                    <><Title level={3}>Select the Hero carousal cards <span style={{ color: '#DA0D50', fontSize: 12 }}>(Max {todaysEvent ? 5 : 6} cards)</span></Title>
                      <RecommendationsSelector
                        allEvents={vlpHeroAllEvents}
                        onSelectedReorder={reorderVLPHeroPromotedEvents}
                        promotedEvents={vlpHeroPromotedEvents}
                        resourceName={'Cards'}
                        setAllEvents={setVLPHeroAllEvents}
                        setPromotedEvents={setVLPHeroPromotedEvents}
                        showSelectedReorder
                      />
                    </>
                  </Card>
                </Panel>
                <Panel key='2' header='Page Meta' style={{
                  fontSize: 20
                }}>
                  <Card style={{ borderColor: '#3642b1' }}>
                    <PageMetaInfo
                      handleDescriptionChange={handlePageMetaDescriptionChange}
                      handleHeadingChange={handlePageMetaHeadingChange}
                      handleKeywordsChange={handlePageMetaKeywordsChange}
                      handleShowSEOChange={handlePageMetaShowSEOChange}
                      handleTextChange={handlePageMetaTextChange}
                      handleTitleChange={handlePageMetaTitleChange}
                      pageMeta={page?.page_meta || {}}
                    />
                  </Card>
                </Panel>
                <Panel key='3'
                  extra={[deleteAllMediaRow, addMediaRow]}
                  header='Media Row'
                  style={{
                    fontSize: 20
                  }}>
                  <Card style={{ borderColor: '#3642b1' }} >
                    <MediaRow deleteMediaRow={deleteMediaRow} media={page?.media_row} setMedia={handleMediaRow} />
                  </Card>
                </Panel>
                <Panel key='4' header='Personalization' style={{
                  fontSize: 20
                }}>
                  <Card style={{ borderColor: '#3642b1' }}>
                    <Row gutter={16}>
                      <Col span={24}>
                        <Row gutter={16}><Title level={5}>Section Header*</Title></Row>
                        <Input maxLength={70} onChange={handleRecommendationSectionTitle} value={page?.recommendations_section_title} />
                      </Col>
                    </Row>
                    {page && !page.recommendations_section_title && <Typography.Paragraph className={styles['paragraph-text']}>Please fill out this field</Typography.Paragraph>}
                    <br/>
                    <Table columns={upcomingEventsColumns} dataSource={recommendedEvents} pagination={false} />
                  </Card>
                </Panel>
                <Panel key='5' header='Upcoming Events' style={{
                  fontSize: 20
                }}>
                  <Card style={{ borderColor: '#3642b1' }}>
                    <Row gutter={16}>
                      <Col span={24}>
                        <Row gutter={16}><Title level={5}>Section Header*</Title></Row>
                        <Input maxLength={70} onChange={handleUpcomingShowsSectionTitle} value={page?.upcoming_shows_section_title} />
                      </Col>
                    </Row>
                    {page && !page.upcoming_shows_section_title && <Typography.Paragraph className={styles['paragraph-text']}>Please fill out this field</Typography.Paragraph>}
                    <br/>
                    <Table columns={upcomingEventsColumns} dataSource={upcomingEvents} pagination={false} />
                  </Card>
                </Panel>
                <Panel key='6' extra={[deleteAllCategoryMarketingPill, addCategoryMarketingPill]} header='Browse Events by Category' style={{
                  fontSize: 20
                }}>
                  <Card style={{ borderColor: '#3642b1' }} >
                    <MarketingPills
                      pills={page?.category_pills}
                      setPills={handleCategoryPills}
                    />
                  </Card>
                </Panel>
                <Panel key='7' extra={[deleteAllMarketingPill, addMarketingPill]} header='What Else Can We Help You With?' style={{
                  fontSize: 20
                }}>
                  <Card style={{ borderColor: '#3642b1' }} >
                    <MarketingPills
                      pills={page?.marketing_pills}
                      setPills={handleMarketingPills}
                    />
                  </Card>
                </Panel>
                <Panel key='8' header='Horizontal Banner Module' style={{
                  fontSize: 20
                }}>
                  <HorizontalBanner horizontalBanner={page?.banner} setHorizontalBanner={handleHorizontalBanner} />
                </Panel>
                <Panel key='9' header='Flockler' style={{
                  fontSize: 20
                }}>
                  <Flockler flockler={page?.social_feeds} setFlockler={handleFlockler} />
                </Panel>
                <Panel key='10' extra={[deleteAllContentCardsPill, addMContentCardPill]} header='Content Card' style={{
                  fontSize: 20
                }}>
                  <Input label={<Title level={3}>Section Header</Title>} onChange={handleContentCardSectionHeaderChange} value={page?.content_cards?.header} />
                  <ContentCard contentCard={page?.content_cards?.cards || []} setContentCard={handleContentCard} />
                </Panel>
              </Collapse>}
            </>
          }
          {
            page?.type === 'faq' && <>
              <Row>
                {venues && <Col xl={24} xs={24}>
                  <MultiSelectDropdown
                    {...(mode === 'edit' ? { disabled: true } : null)}
                    allowClear={true}
                    customStyle={{ width: 450 }}
                    displayField='name'
                    dropdownOptions={venues}
                    handleChange={handleVenueChange}
                    label={<Title level={3}>Venue*</Title>}
                    selectedItems={page?.venue_id}
                    valueField='_id'
                  /><br />
                </Col>}
              </Row>
              {page?.venue_id && <Collapse accordion defaultActiveKey={['2']} destroyInactivePanel={false} expandIconPosition='right'>
                <Panel key='1' header='Hero' style={{ fontSize: 20 }}>
                  <FAQHeroFields
                    hero={page?.hero}
                    onImageUpload={handleFAQHeroImageUpload}
                    onTitleChange={handleFAQHeroTitleChange}
                    venueName={page?.venue?.name || venues?.find(v => v._id === page?.venue_id)?.name}
                  />
                </Panel>
                <Panel
                  key='2'
                  header={`FAQ Sections${(page?.sections?.length || 0) ? ` (${page.sections.length})` : ''}`}
                  style={{ fontSize: 20 }}
                >
                  <FAQPageSections
                    sections={page?.sections || []}
                    setSections={handleFAQPageSections}
                  />
                </Panel>
                <Panel key='3' header='Attending' style={{ fontSize: 20 }}>
                  <FAQAttendingFields
                    attending={page?.attending}
                    onFieldChange={handleFAQAttending}
                  />
                </Panel>
                {page?.show_advertisement_banner && (
                  <Panel key='4' header='Advertisement Banner' style={{ fontSize: 20 }}>
                    <HorizontalBanner
                      horizontalBanner={page?.banner}
                      setHorizontalBanner={handleHorizontalBanner}
                    />
                  </Panel>
                )}
                <Panel key='5' header='Page Meta' style={{ fontSize: 20 }}>
                  <Card style={{ borderColor: '#3642b1' }}>
                    <PageMetaInfo
                      handleDescriptionChange={handlePageMetaDescriptionChange}
                      handleHeadingChange={handlePageMetaHeadingChange}
                      handleKeywordsChange={handlePageMetaKeywordsChange}
                      handleShowSEOChange={handlePageMetaShowSEOChange}
                      handleTextChange={handlePageMetaTextChange}
                      handleTitleChange={handlePageMetaTitleChange}
                      pageMeta={page?.page_meta || {}}
                    />
                  </Card>
                </Panel>
              </Collapse>}
            </>
          }
          {
            page?.type === 'tours' && <><Row>
              {tourVenues && <Col xl={24} xs={24}>
                <MultiSelectDropdown
                  {...(mode === 'edit' ? { disabled: true } : null)}
                  allowClear={true}
                  customStyle={{ width: 450 }}
                  displayField='name'
                  dropdownOptions={tourVenues}
                  handleChange={handleVenueChange}
                  label={<Title level={3}>Venue*</Title>}
                  selectedItems={page?.venue_id}
                  valueField='_id'
                /><br />
              </Col>}
            </Row>
            { page?.venue_id && <Collapse accordion defaultActiveKey={['0']} expandIconPosition='right'>
              <Panel key='1' extra={ [deleteAllNavLink, addNavLink] } header='Jump links' style={{ fontSize: 20 }}>
                <AnchorLinks anchorLinks={page?.anchor_links} setAnchorLinks={setAnchorLinks}/>
              </Panel>
              <Panel key='2' header='Hero' style={{ fontSize: 20 }}>
                <Card style={{ borderColor: '#3642b1' }}>
                  <HeroBasicInfo
                    handleButtonLabelChange={handleHeroButtonLabelChange}
                    handleChatLabelChange={handleHeroChatLabelChange}
                    handleContentChange={handleHeroDescriptionChange}
                    handleEmailChange={handleHeroEmailChange}
                    handleFormIdChange={handleHeroFormIdChange}
                    handleImageChange={handleImageChange}
                    handleImageUrlChange={handleImageUrlChange}
                    handleImageUrlUpdate={handleHeroImageUrlUpdate}
                    handlePhoneNumberChange={handleHeroPhoneNumberChange}
                    handleSubTitleChange={handleHeroSubTitleChange}
                    handleTitleChange={handleHeroTitleChange}
                    hero={page?.hero || {}}
                    pageType={page?.type || 'tours'}
                  />
                </Card>
              </Panel>
              <Panel key='3' header='Form' style={{
                fontSize: 20
              }}>
                <Card>
                  <PageForm
                    form={page?.form || {}}
                    handleButtonTextUpdate={handleButtonTextUpdate}
                    handleDescriptionChange={handleFormModuleDescriptionChange}
                    handleDisclaimerChange={handleFormModuleDisclaimerChange}
                    handleFormIdUpdate={handleFormModuleIdUpdate}
                    handleHeaderChange={handleFormModuleHeaderChange}
                    handleMessageChange={handleFormModuleMessageChange}
                    handleSuccessSubmitButtonUpdate={handleFormModuleSuccessSubmitButtonTextUpdate}
                    handleTitleChange={handleFormModuleTitleChange}
                  />
                </Card>
              </Panel>
              <Panel key='4' header='Page Meta' style={{
                fontSize: 20
              }}>
                <Card style={{ borderColor: '#3642b1' }}>
                  <PageMetaInfo
                    handleDescriptionChange={handlePageMetaDescriptionChange}
                    handleHeadingChange={handlePageMetaHeadingChange}
                    handleKeywordsChange={handlePageMetaKeywordsChange}
                    handleShowSEOChange={handlePageMetaShowSEOChange}
                    handleTextChange={handlePageMetaTextChange}
                    handleTitleChange={handlePageMetaTitleChange}
                    pageMeta={page?.page_meta || {}}
                  />
                </Card>
              </Panel>
              <Panel key='5' extra={[showCalendar]} header='Calendar' style={{
                fontSize: 20
              }}>
                <Card style={{ borderColor: '#3642b1' }}>
                  <Input label='Title' onChange={handleCalendarTitleChange} value={page?.calendar?.title} />
                  <Row align={'left'}>
                    <Col><Title level={3}>Description</Title></Col>
                  </Row>
                  <Row style={{ minHeight: 120, height: '100%', width: '100%' }}>
                    <RichTextContentEditor
                      onChange={handleCalendarDescriptionChange}
                      value={page?.calendar?.description || ''}
                    />
                  </Row>
                </Card>
              </Panel>
              <Panel key='6' extra={[deleteAllGalleryItems, addNewGallery]} header='Videos & Photos' style={{
                fontSize: 20
              }}>
                <Collapse accordion defaultActiveKey={['0']} expandIconPosition='right'>
                  <Card>
                    <Row gutter={16} style={{ padding: 12 }}>
                      <Col span={24}>
                        <Row>Section Header</Row>
                        <Input onChange={handleGallerySectionTitle} value={gallery_header || ''} />
                      </Col>
                    </Row>
                  </Card>
                  { galleries && <DatafieldGallery
                    deleteGallery={deleteGallery}
                    galleries={galleries}
                    handleGalleryChange={handleGalleryChange}
                    handleGalleryImageAltChange={handleGalleryImageAltChange}
                    handleGalleryImageUrlUpdate={handleGalleryImageUrlUpdate}
                    handleGalleryMediaChange={handleGalleryMediaChange}
                    handleGallerySubTitleChange={handleGallerySubTitleChange}
                    handleGalleryTitleChange={handleGalleryTitleChange}
                    setGallery={setGallery}
                  />}
                </Collapse>
              </Panel>
              <Panel key='7' extra={[deleteMarketingModules, addMarketingModule]} header='Marketing Modules' style={{
                fontSize: 20
              }}>
                <Collapse accordion defaultActiveKey={['0']} expandIconPosition='right'>
                  <TourMarketingCard marketingModules={page?.marketing_modules || []} pageType={page?.type || 'tours'} setMarketingModules={setMarketingModules}/>
                </Collapse>
              </Panel>
              <Panel key='8' extra={[deleteAllPriceCard, addPriceCard]} header='Price Cards' style={{
                fontSize: 20
              }}>
                <Input label={<Title level={3}>Section Header</Title>} onChange={handlePriceCardSectionHeaderChange} value={page?.tours_prices?.header} />
                <Row align={'left'}>
                  <Col><Title level={3}>Description</Title></Col>
                </Row>
                <Row style={{ minHeight: 120, height: '100%', width: '100%' }}>
                  <RichTextContentEditor
                    onChange={handleTourPlanDescriptionChange}
                    value={page?.tours_prices?.html_description || ''}
                  />
                </Row>
                <Row align={'left'}>
                  <Col><Title level={3}>Disclaimer</Title></Col>
                </Row>
                <Row style={{ minHeight: 120, height: '100%', width: '100%' }}>
                  <RichTextContentEditor
                    onChange={handlePriceCardDisclaimerChange}
                    value={page?.tours_prices?.disclaimer || ''}
                  />
                </Row>
                {/* <Input label={<Title level={3}>Disclaimer</Title>} onChange={handlePriceCardDisclaimerChange} value={page?.tours_prices?.disclaimer} /> */}
                <PriceCards priceCard={page?.tours_prices?.cards || []} setPriceCards={handlePriceCard} />
              </Panel>
              <Panel key='9' extra={[deleteAllFAQModules, addFAQModule]} header='FAQs' style={{
                fontSize: 20
              }}>
                <Input label={<Title level={3}>Header</Title>} onChange={handleFAQsSectionHeaderChange} value={page?.faqs?.header} />
                <FAQModules addNewFAQImage={addNewFAQImage} deleteAllFAQsImages={deleteAllFAQsImages} flexModules={page?.faqs?.flex_modules || []} setFlexModules={handleFAQs} />
              </Panel>
              <Panel key='10' header='Overview' style={{
                fontSize: 20
              }}>
                <Input label={<Title level={3}>Header</Title>} onChange={handleOverviewSectionHeaderChange} value={page?.overview?.header} />
                <Row align={'left'}>
                  <Col><Title level={3}>Description</Title></Col>
                </Row>
                <Row style={{ minHeight: 120, height: '100%', width: '100%' }}>
                  <RichTextContentEditor
                    onChange={handleOverviewDescriptionChange}
                    value={page?.overview?.html_description || ''}
                  />
                </Row>
              </Panel>
            </Collapse>}
            </>
          }
        </>
      )}
    </Card>
  )
}

PageBasicInfo.propTypes = {
  addContentModule: PropTypes.func.isRequired,
  addGallery: PropTypes.func,
  addNewCategoryPill: PropTypes.func,
  addNewContentCardPill: PropTypes.func,
  addNewFAQ: PropTypes.func,
  addNewFAQImage: PropTypes.func,
  addNewLink: PropTypes.func,
  addNewMarketingModule: PropTypes.func,
  addNewMarketingPill: PropTypes.func,
  addNewMediaIcon: PropTypes.func.isRequired,
  addNewPriceCard: PropTypes.func,
  addSuitesCardModule: PropTypes.func.isRequired,
  allELSEvents: PropTypes.array,
  allIsLEvents: PropTypes.array,
  allLSLEvents: PropTypes.array,
  allSuiteLevels: PropTypes.array.isRequired,
  concessionErrors: PropTypes.object,
  deleteAllCategoryPills: PropTypes.func,
  deleteAllContentCards: PropTypes.func,
  deleteAllFAQs: PropTypes.func,
  deleteAllFAQsImages: PropTypes.func,
  deleteAllGallery: PropTypes.func,
  deleteAllLink: PropTypes.func,
  deleteAllMarketingModules: PropTypes.func,
  deleteAllMarketingPills: PropTypes.func,
  deleteAllMediaIcon: PropTypes.array.isRequired,
  deleteAllPriceCards: PropTypes.func,
  deleteContentModule: PropTypes.func.isRequired,
  deleteCtgyPill: PropTypes.func,
  deleteGallery: PropTypes.func,
  deleteMediaRow: PropTypes.func,
  deleteMktPill: PropTypes.func,
  deleteSuitesCardModule: PropTypes.func.isRequired,
  galleries: PropTypes.array,
  gallery_header: PropTypes.string,
  handleAddCta: PropTypes.func.isRequired,
  handleAddUniversalModule: PropTypes.func,
  handleAllEventsChange: PropTypes.func.isRequired,
  handleAutoplay: PropTypes.func,
  handleButtonTextUpdate: PropTypes.func.isRequired,
  handleCalendarDescriptionChange: PropTypes.func.isRequired,
  handleCalendarTitleChange: PropTypes.func.isRequired,
  handleCategoryPills: PropTypes.func,
  handleChatPopUpIdChange: PropTypes.func,
  handleConcessionDisclaimerChange: PropTypes.func,
  handleConcessionFeaturedVendorChange: PropTypes.func,
  handleConcessionFoodAndDrinkChange: PropTypes.func,
  handleConcessionHeroBannerChange: PropTypes.func,
  handleConcessionMediaCarouselChange: PropTypes.func,
  handleConcessionPromotionalVideoChange: PropTypes.func,
  handleConcessionVendorGridChange: PropTypes.func,
  handleConcessionVenuePartnerBenefitsChange: PropTypes.func,
  handleContentCard: PropTypes.func,
  handleContentCardSectionHeaderChange: PropTypes.func,
  handleContentModuleCTANameChange: PropTypes.func.isRequired,
  handleContentModuleCTAUrlChange: PropTypes.func.isRequired,
  handleContentModuleContentChange: PropTypes.func.isRequired,
  handleContentModuleHeaderChange: PropTypes.func.isRequired,
  handleContentModuleImageUrlUpdate: PropTypes.func.isRequired,
  // eslint-disable-next-line
  handleCTAHrefChange: PropTypes.func.isRequired,
  // eslint-disable-next-line
  handleCTATitleChange: PropTypes.func.isRequired,
  handleCtgyCTANameChange: PropTypes.func,
  handleCtgyCTAUrlChange: PropTypes.func,
  handleCtgyIconChange: PropTypes.func,
  handleCtgyImageUrlUpdate: PropTypes.func,
  handleDeleteCta: PropTypes.func.isRequired,
  handleDeleteUniversalModule: PropTypes.func,
  handleDescriptionChange: PropTypes.func,
  handleEvergreenChange: PropTypes.func,
  handleExpiresAtChange: PropTypes.func,
  handleFAQAttending: PropTypes.func,
  handleFAQHeroImageUpload: PropTypes.func,
  handleFAQHeroTitleChange: PropTypes.func,
  handleFAQPageSections: PropTypes.func,
  handleFAQs: PropTypes.func,
  handleFAQsSectionHeaderChange: PropTypes.func,
  handleFlockler: PropTypes.func,
  handleFormModuleDescriptionChange: PropTypes.func.isRequired,
  handleFormModuleDisclaimerChange: PropTypes.func.isRequired,
  handleFormModuleHeaderChange: PropTypes.func.isRequired,
  handleFormModuleIdUpdate: PropTypes.func.isRequired,
  handleFormModuleMessageChange: PropTypes.func.isRequired,
  handleFormModuleSuccessSubmitButtonTextUpdate: PropTypes.func.isRequired,
  handleFormModuleTitleChange: PropTypes.func.isRequired,
  handleGalleryChange: PropTypes.func,
  handleGalleryImageAltChange: PropTypes.func,
  handleGalleryImageUrlUpdate: PropTypes.func,
  handleGalleryMediaChange: PropTypes.func,
  handleGallerySectionTitle: PropTypes.func.isRequired,
  handleGallerySubTitleChange: PropTypes.func,
  handleGalleryTitleChange: PropTypes.func,
  handleHeroButtonLabelChange: PropTypes.func.isRequired,
  handleHeroChatLabelChange: PropTypes.func.isRequired,
  handleHeroContentChange: PropTypes.func.isRequired,
  handleHeroDescriptionChange: PropTypes.func.isRequired,
  handleHeroEmailChange: PropTypes.func.isRequired,
  handleHeroFormIdChange: PropTypes.func.isRequired,
  handleHeroImageUrlUpdate: PropTypes.func.isRequired,
  handleHeroPhoneNumberChange: PropTypes.func.isRequired,
  handleHeroSubTitleChange: PropTypes.func.isRequired,
  handleHeroTitleChange: PropTypes.func.isRequired,
  handleHorizontalBanner: PropTypes.func,
  handleImageChange: PropTypes.func,
  handleImageUrlChange: PropTypes.func,
  handleMarketingPills: PropTypes.func,
  handleMediaRow: PropTypes.func,
  handleMktCTANameChange: PropTypes.func,
  handleMktCTAUrlChange: PropTypes.func,
  handleMktIconChange: PropTypes.func,
  handleMktImageUrlUpdate: PropTypes.func,
  handleOverviewDescriptionChange: PropTypes.func,
  handleOverviewSectionHeaderChange: PropTypes.func,
  handlePageMetaDescriptionChange: PropTypes.func.isRequired,
  handlePageMetaHeadingChange: PropTypes.func.isRequired,
  handlePageMetaKeywordsChange: PropTypes.func.isRequired,
  handlePageMetaShowSEOChange: PropTypes.func.isRequired,
  handlePageMetaTextChange: PropTypes.func.isRequired,
  handlePageMetaTitleChange: PropTypes.func.isRequired,
  handlePageNameChange: PropTypes.func.isRequired,
  handlePageSubtypeChange: PropTypes.func,
  handlePageTypeChange: PropTypes.func.isRequired,
  handlePopularSearchesChange: PropTypes.func,
  handlePriceCard: PropTypes.func,
  handlePriceCardDisclaimerChange: PropTypes.func,
  handlePriceCardSectionHeaderChange: PropTypes.func,
  handleRecommendationSectionTitle: PropTypes.func.isRequired,
  handleSearchTagsChange: PropTypes.func,
  handleSelectedEventsChange: PropTypes.func.isRequired,
  handleShowCalendar: PropTypes.func,
  handleShowInGoogleSearchChange: PropTypes.func,
  handleShowInInternalSearchChange: PropTypes.func,
  handleSlugChange: PropTypes.func.isRequired,
  handleSuiteAmenitiesChange: PropTypes.func.isRequired,
  handleSuiteCapacityChange: PropTypes.func.isRequired,
  handleSuiteCardShortNameChange: PropTypes.func.isRequired,
  handleSuiteCardTypeChange: PropTypes.func.isRequired,
  // eslint-disable-next-line
  handleSuiteCTAUpdate: PropTypes.func.isRequired,
  handleSuiteEventIdeasChange: PropTypes.func.isRequired,
  handleSuiteEventTypeChange: PropTypes.func.isRequired,
  handleSuiteFormStatus: PropTypes.func.isRequired,
  handleSuiteHospitalityChange: PropTypes.func.isRequired,
  handleSuiteLogoUpload: PropTypes.func.isRequired,
  handleSuiteSizeChange: PropTypes.func.isRequired,
  handleSuiteSubTitleChange: PropTypes.func.isRequired,
  handleSuiteTitleChange: PropTypes.func.isRequired,
  handleTourPlanDescriptionChange: PropTypes.func,
  handleUniversalModuleReorder: PropTypes.func,
  handleUniversalModuleUpdate: PropTypes.func,
  handleUpcomingShowsSectionTitle: PropTypes.func.isRequired,
  handleVenueChange: PropTypes.func,
  handleVenueRentalsHeroChange: PropTypes.func,
  mode: PropTypes.string.isRequired,
  page: PropTypes.object.isRequired,
  pageTypes: PropTypes.array,
  promotedEvents: PropTypes.array,
  recommendedEvents: PropTypes.array.isRequired,
  reorderVLPHeroPromotedEvents: PropTypes.func,
  selectedELSEvents: PropTypes.array,
  selectedIsLEvents: PropTypes.array,
  selectedLSLEvents: PropTypes.array,
  selectedType: PropTypes.object,
  setAllELSEvents: PropTypes.func,
  setAllEvents: PropTypes.func.isRequired,
  setAllIsLEvents: PropTypes.func,
  setAllLSLEvents: PropTypes.func,
  setAnchorLinks: PropTypes.func,
  setGallery: PropTypes.func,
  setMarketingModules: PropTypes.func,
  setPromotedEvents: PropTypes.func.isRequired,
  setSelectedELSEvents: PropTypes.func,
  setSelectedIsLEvents: PropTypes.func,
  setSelectedLSLEvents: PropTypes.func,
  setVLPHeroAllEvents: PropTypes.func,
  setVLPHeroPromotedEvents: PropTypes.func,
  showConcessionValidationErrors: PropTypes.bool,
  suitesAmenities: PropTypes.array.isRequired,
  suitesCapacity: PropTypes.array.isRequired,
  suitesEventIdeas: PropTypes.array.isRequired,
  suitesEventType: PropTypes.array.isRequired,
  suitesHospitality: PropTypes.array.isRequired,
  suitesSize: PropTypes.array.isRequired,
  todaysEvent: PropTypes.array.isRequired,
  tourVenues: PropTypes.array.isRequired,
  universalTemplateErrors: PropTypes.object,
  upcomingEvents: PropTypes.array.isRequired,
  venues: PropTypes.array.isRequired,
  vlpHeroAllEvents: PropTypes.array.isRequired,
  vlpHeroPromotedEvents: PropTypes.array.isRequired
}

PageBasicInfo.defaultProps = {
  page: {}
}

export default PageBasicInfo
